/**
 * ChangeContextHeader
 * Renders the change-context summary shown at the top of a preview modal as an
 * info Alert — e.g. "Maturity: 2026 → 2027", "Rate: 10% → 12%", "Rolled: ...".
 *
 * Accepts a structured `lines` array of { label, value } so callers pass the raw
 * change context instead of a pre-formatted string, keeping formatting consistent
 * across the rollover / extend / rate-change previews. Falls back to a plain
 * `subtitle` string when no structured lines are supplied.
 */

import React from 'react';
import { Alert, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const ChangeContextHeader = ({ lines, subtitle, severity = 'info' }) => {
  const hasLines = Array.isArray(lines) && lines.filter((l) => l && l.value != null && l.value !== '').length > 0;

  if (!hasLines && !subtitle) return null;

  return (
    <Alert severity={severity} icon={<InfoIcon />} sx={{ mb: 2 }}>
      {hasLines ? (
        <Typography variant="body2" component="div">
          {lines
            .filter((l) => l && l.value != null && l.value !== '')
            .map((l, idx) => (
              <span key={l.label || idx} style={{ display: 'block' }}>
                <strong>{l.label}:</strong> {l.value}
              </span>
            ))}
        </Typography>
      ) : (
        <Typography variant="body2">{subtitle}</Typography>
      )}
    </Alert>
  );
};

export default ChangeContextHeader;
